export default function Upgrade() {
    return (
        <div style={{ padding: "20px", textAlign: "center" }}>
            <h1>Opgrader til Pro</h1>
            <p>Kommer Snart...</p>
            <p>Få adgang til eksklusive funktioner og forbedret support ved at opgradere til Pro-versionen.</p>
        </div>
    );
}
            